import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessDesignActivityCount } from './process-design-activity-count';
export { ProcessDesignActivityCount };
import { processDesignActivityCountSchema } from '@schemas/business-objects/process-design-activity-count';
import { ProcessDesignFormGroup } from './process-design-form-group';
import { TenantFormGroup } from './tenant-form-group';

export class ProcessDesignActivityCountFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    activityId: SchemaFormControl;
    status: SchemaFormControl;
    tokenCount: SchemaFormControl;
    designUuid: SchemaFormControl;
    processDesignId: SchemaFormControl;
    processDesign: ProcessDesignFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<ProcessDesignActivityCount>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(
      processDesignActivityCountSchema,
      ProcessDesignActivityCount,
      data,
      options,
    );
  }

  get object(): ProcessDesignActivityCount {
    return new ProcessDesignActivityCount(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processDesign':
        return new ProcessDesignFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessDesignActivityCount[]> {
    return ProcessDesignActivityCount.find(filter);
  }

  static async findOne(
    filter?: any,
  ): Promise<ProcessDesignActivityCount | null> {
    return ProcessDesignActivityCount.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessDesignActivityCount> {
    return ProcessDesignActivityCount.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessDesignActivityCount>,
  ): Promise<ProcessDesignActivityCount> {
    return ProcessDesignActivityCount.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessDesignActivityCount>,
  ): Promise<ProcessDesignActivityCount> {
    return ProcessDesignActivityCount.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessDesignActivityCount.deleteById(id);
  }
}

export class ProcessDesignActivityCountFormArray extends PersistedFormArray {
  declare controls: ProcessDesignActivityCountFormGroup[];

  readonly entityName = 'ProcessDesignActivityCount' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(
      processDesignActivityCountSchema,
      ProcessDesignActivityCount,
      options,
    );
  }

  protected override createItemGroup() {
    return new ProcessDesignActivityCountFormGroup();
  }

  get array(): ProcessDesignActivityCount[] {
    return this.controls.map(
      (group: ProcessDesignActivityCountFormGroup) => group.object,
    );
  }
}

export class ProcessDesignActivityCountPersistedArray extends PersistedArray<ProcessDesignActivityCount> {
  readonly entityName = 'ProcessDesignActivityCount' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessDesignActivityCount, options);
  }
}
